import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';
import { FormattedMessage } from 'react-intl';

import { FontAwesomeIcon } from '@sorare/core/src/atoms/icons';
import { iconAlert } from '@sorare/core/src/atoms/icons/system/iconAlert.ts';
import { Horizontal } from '@sorare/core/src/atoms/layout/flex';
import { LabelXS } from '@sorare/core/src/atoms/typography';
import { playerUnavailability } from '@sorare/core/src/lib/glossary';

import type { BenchExtraInjury_anyPlayerInterface } from './__generated__/index.graphql.ts';

type Props = {
  anyPlayer: BenchExtraInjury_anyPlayerInterface;
  iconOnly?: boolean;
};

export const BenchExtraInjury = ({ anyPlayer, iconOnly }: Props) => {
  const [injury] = anyPlayer.activeInjuries;
  const isOut = ['OFS', 'OUT'].includes(injury.status!);

  return (
    <Horizontal gap={0.5} center>
      <FontAwesomeIcon
        icon={iconAlert}
        color={isOut ? 'var(--c-red-400)' : 'var(--c-yellow-400)'}
        width={12}
      />
      {!iconOnly && (
        <>
          {injury.status ? (
            <LabelXS color={isOut ? 'var(--c-red-300)' : 'var(--c-yellow-500)'}>
              {injury.status}
            </LabelXS>
          ) : (
            <LabelXS>
              <FormattedMessage {...playerUnavailability.injuryTitle} />
            </LabelXS>
          )}
        </>
      )}
    </Horizontal>
  );
};

BenchExtraInjury.fragments = {
  anyPlayer: gql`
    fragment BenchExtraInjury_anyPlayerInterface on AnyPlayerInterface {
      slug
      activeInjuries {
        id
        status
      }
    }
  ` as TypedDocumentNode<BenchExtraInjury_anyPlayerInterface>,
};
